export default "__VITE_ASSET__D4WF7pCd__"